export default function getFieldOptionTranslation(option: any) {
    if (!option.translations) {
        return option.key;
    }

    const translation = option.translations.find((translation: any) => translation.locale === 'en') ?? option.translations[0];

    return translation.name;
}
